// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"33":"d2adf694","71":"efb878d6"}[chunkId] + ".chunk.js";
};